const Version = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
  routes: [
    {
      path: '/papr/version',
      name: 'papr_version',
      component: Version
    }
  ]
}
